import { Component } from "@theme/component";
import { debounce, fetchConfig } from "@theme/utilities";

/**
 * A custom element that displays a cart note.
 */
class CartNote extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  toggleGiftNote(event) {
    const textarea = this.querySelector("textarea");
    if (!(textarea instanceof HTMLTextAreaElement)) return;

    if (event.target.checked) {
      textarea.focus();
    } else {
      textarea.value = "";
      textarea.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  /**
   * Handles updates to the cart note.
   * @param {InputEvent} event - The input event in our text-area.
   */
  updateCartNote = debounce(async (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;

    const note = event.target.value;
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ note }),
      });

      await fetch(FoxTheme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
    } catch (error) {
    } finally {
      if (this.#activeFetch === abortController) this.#activeFetch = null;
      // cartPerformance.measureFromEvent("note-update:user-action", event);
    }
  }, 200);
}

if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}
